import {Component, Input, OnInit, ChangeDetectionStrategy} from "@angular/core";

import {NotificationMessage} from "./notification-message.model";

@Component({
    selector: 'qnect-error-notification',
    templateUrl: './error-notification.component.html',
    styleUrls: ['./notification.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ErrorNotificationComponent implements OnInit {

  @Input()
  messages: NotificationMessage[] = [];
  @Input() showPreamble: boolean = true;

  constructor() {
  }

  ngOnInit() {
  }

}
